import upperCase from 'lodash/upperCase';

const getInitials = (firstName: string, lastName: string) => [firstName, lastName]
  .map(upperCase)
  .map(text => text.charAt(0))
  .join('');

export default getInitials;
